// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__uoXC7","modal":"Modal_modal__VVuHb","header":"Modal_header__Mb1aW","modalContent":"Modal_modalContent__nCaSe","close":"Modal_close__T1eB0"};